import React from 'react';
import styles from './InfoRow.module.css';

interface InfoRowProps {
  label: string;
  value: string | number | boolean | null | undefined;
  type?: 'text' | 'boolean' | 'date' | 'currency';
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value, type = 'text' }) => {
  const renderValue = () => {
    if (value === null || value === undefined || value === '') {
      return <span className={styles['info-value-not-informed']}>Não informado</span>;
    }

    if (type === 'boolean' || typeof value === 'boolean') {
      return value ? (
        <span className={styles['info-value-yes']}>Sim</span>
      ) : (
        <span className={styles['info-value-no']}>Não</span>
      );
    }

    return <span>{String(value)}</span>;
  };

  return (
    <div className={styles['info-row']}>
      <span className={styles['info-label']}>{label}</span>
      <span className={styles['info-value']}>{renderValue()}</span>
    </div>
  );
};

export default InfoRow;
